import { observer } from 'mobx-react';
import { useEffect, useRef, useState } from 'react';
import toast from 'react-hot-toast';
import { FormattedMessage } from 'react-intl';
import { MultiSelect } from 'react-multi-select-component';
import noMessageIcon from '../../../assets/Images/no-hkr.png';
import ReorderProcess from '../../../assets/Images/reorderProcess.svg';
import ReorderProcessPopupHOC from '../../active-tray-mgmt/hoc/reorder-process-popup-hoc';
import HKRColumnReorder from './components/hkr-column-reorder';
import userSettingEnum from '../../../constants/enums/user-setting-enum';
import { GridRemoteConstant } from '../../../constants/grid-constant';
import { useStore } from '../../../contexts/store-provider';
import {
  HKRSchdefuleDefaultSortColumnOrder,
  HKRScheduleFilterInitialState,
} from '../../../core/initialState/filter-initial-state';
import { getTenantIdFromLocalStorage } from '../../../helpers/localstorage-helper';
import IPageInfo, { IPageLimitInfo } from '../../../models/ICommon';
import IDefaultColumSortOrder from '../../../models/IDefaultColumSortOrder';
import { IHKRSchdeuleFilter } from '../../../models/IHKRScheduleFilter';
import FormLoader from '../../../shared-components/FormLoader/FormLoader';
import Grid from '../../../shared-components/Grid/Grid';
import Pagination from '../../../shared-components/Grid/Pagination';
import Header from '../../../shared-components/header/header';
import FilterPopupHOC from '../../../shared-components/hoc/filter-popup-hoc/filter-popup-hoc';
import DeletePopupHOC from '../../../shared-components/popup/delete/delete-popup-hoc';
import { RefreshIcon } from '../../../shared-components/svgs/svgs';
import { formatMessage } from '../../../translations/format-message';
import FilterComponent from './components/filter';
import './hkr-dashboard-data-view.css';
import { title } from 'process';

const HKRDashboardDataView = (props: any) => {
  const { preferencesStore, dashboardStore, activeTrayManagementStore } =
    useStore();
  const {
    getHKRDashboardDataServiceState,
    hkrDashboardDataList,
    GetHKRDashboardDataService,
    allHKRDashboardData,
    allProcesses,
    visibleHKRColumnsList,
  } = dashboardStore;

  const {
    userSetting,
    setUserSetting,
    language,
    islanguageChanged,
    updateLanguageChangedFlag,
  } = preferencesStore;

  const {
    SaveProcessOrderService,
    saveProcessOrderState,
    resetSaveProcessOrderState,
  } = activeTrayManagementStore;

  let lang: string;
  const allHKRDashboardDataList = allHKRDashboardData;

  const [columSortOrder, setColumnSortOrder] = useState<IDefaultColumSortOrder>(
    HKRSchdefuleDefaultSortColumnOrder
  );

  const isFirstLoad = useRef(true);
  const initialSelection = visibleHKRColumnsList;
  const [allowedColumns, setAllowedColumns] = useState([]);
  const [selected, setSelected] = useState([...visibleHKRColumnsList]);
  const [disablePagination, setDisablePagination] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [selectedId, setSelectedId] = useState(0);
  const [openPanel, setOpenPanel] = useState(false);
  const pageLimitOptions: Array<number> = [50, 100, 500, 1000];
  const [isFilterCleared, setIsFilterCleared] = useState(true);
  const [filterObj, setFilterObj] = useState<IHKRSchdeuleFilter>(
    HKRScheduleFilterInitialState
  );
  const [isFilterApplied, setIsFilterApplied] = useState<boolean>(false);

  const [pageLimitInfo, setPageLimit] = useState<IPageLimitInfo>({
    pageLimit: userSetting.pageLimitConfig,
    isPageLimitChange: false,
  });

  const [pageInfo, setPageInfo] = useState<IPageInfo>({
    currentPage: 1,
    totalPages: 1,
    isPagerChange: false,
    isRefreshPage: false,
  });

  const onPageChanged = (pageNumber: number) => {
    closePanelHandler();
    setPageInfo({ ...pageInfo, currentPage: pageNumber, isPagerChange: true });
  };

  const setIsRefreshPage = () => {
    setPageInfo({ ...pageInfo, isRefreshPage: false });
  };

  const onPageLimitChanged = (evt: any) => {
    let pages: number;
    pages = props.data && Math.ceil(props.data.length / evt.target.value);
    setPageInfo({
      ...pageInfo,
      currentPage: 1,
      totalPages: pages,
      isPagerChange: false,
    });
    setPageLimit({
      pageLimit: parseInt(evt.target.value),
      isPageLimitChange: true,
    });
    setUserSetting(userSettingEnum.UserLimitConfig, parseInt(evt.target.value));
  };

  const getHKRScheduleViewServiceHandler = (
    filterQuery?: string,
    isFilter = false
  ) => {
    if (!filterQuery) {
      filterQuery = createQueryString({ ...filterObj });
    }
    if (!isFilter) {
      GetHKRDashboardDataService(
        Number(getTenantIdFromLocalStorage()),
        pageLimitInfo.pageLimit,
        pageInfo.currentPage,
        encodeURIComponent(filterQuery)
      );
    } else {
      GetHKRDashboardDataService(
        Number(getTenantIdFromLocalStorage()),
        pageLimitInfo.pageLimit,
        1,
        encodeURIComponent(filterQuery)
      );
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      getHKRScheduleViewServiceHandler();
    }, 600000);

    return () => clearInterval(interval);
  }, [pageInfo]);

  useEffect(() => {
    getHKRScheduleViewServiceHandler();
  }, []);

  useEffect(() => {
    if (visibleHKRColumnsList.length > 0) {
      setAllowedColumns([
        ...visibleHKRColumnsList.map((p) => p.label),
        'Kishu',
        'ProcessDueDate',
        'Remaining',
      ]);
      setSelected([...initialSelection]);
    }
  }, [visibleHKRColumnsList.length]);

  useEffect(() => {
    if (islanguageChanged) {
      updateLanguageChangedFlag();
    }
  }, [islanguageChanged]);

  useEffect(() => {
    setPageInfo({
      ...pageInfo,
      currentPage: hkrDashboardDataList?.PagingDetails?.CurrentPage,
      totalPages: hkrDashboardDataList?.PagingDetails?.TotalPages,
      isPagerChange: false,
    });
    setDisablePagination(false);
  }, [hkrDashboardDataList]);

  useEffect(() => {
    if (pageInfo.isPagerChange) {
      getHKRScheduleViewServiceHandler();
    }
  }, [pageInfo.currentPage]);

  useEffect(() => {
    if (pageLimitInfo.isPageLimitChange) {
      getHKRScheduleViewServiceHandler();
      setPageLimit({ ...pageLimitInfo, isPageLimitChange: false });
    }
  }, [pageLimitInfo.pageLimit]);

  useEffect(() => {
    if (lang && language !== lang) {
      getHKRScheduleViewServiceHandler();
    }
  }, [language]);

  function rowClassFormat(row: any, rowId: number) {
    let className: string = '';
    if (selectedRow?.Id && row.Id === selectedRow.Id) {
      className = 'bg-row SelectedRow';
    }
    return className;
  }

  const closePanelHandler = () => {
    setSelectedRow({});
    setOpenPanel(false);
  };

  const refreshClickHandler = () => {
    const filter = createQueryString({ ...filterObj });
    getHKRScheduleViewServiceHandler(filter);
    closePanelHandler();
  };

  function getFieldName(field: string): string {
    switch (field) {
      case 'ProcessDueDate':
        return 'planed_due_date';
      default:
        return 'planed_due_date';
    }
  }

  const createQueryString = (filter: IHKRSchdeuleFilter): string => {
    return Object.entries(filter)
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join('#');
  };

  const filterHandler = (object: IHKRSchdeuleFilter) => {
    const filter = createQueryString({
      ...object,
      Column: getFieldName(columSortOrder.dataField),
      Order: columSortOrder.order,
    });
    getHKRScheduleViewServiceHandler(filter, true);
    setFilterObj({
      ...object,
      Column: columSortOrder.dataField,
      Order: columSortOrder.order,
    });
    props.filterPopupToggleHandler();
    closePanelhandler();
    setIsFilterCleared(false);
  };

  const closePanelhandler = () => {
    setSelectedRow({});
    setOpenPanel(false);
  };

  const filterParams = (obj: IHKRSchdeuleFilter, isfilterCleard: boolean) => {
    const filter = createQueryString({
      ...obj,
      Column: getFieldName(columSortOrder.dataField),
      Order: columSortOrder.order,
    });

    if (isfilterCleard) {
      setFilterObj({ ...obj });
      getHKRScheduleViewServiceHandler(filter);
      closePanelhandler();
      setIsFilterCleared(true);
    } else {
      setFilterObj({ ...obj });
    }
    props.filterPopupToggleHandler();
  };

  const dynamicColumns =
    (hkrDashboardDataList.HKRTableData[0] &&
      hkrDashboardDataList.HKRTableData[0].HKRProcessList.map((item) => ({
        dataField: item.ProcessShortName,
        text: item.ProcessShortName,
        classes: 'show-Elipses',
        headerFormatter: (column) => {
          return (
            <span
              title={item.ProcessName}
              style={{
                border: 'none',
                fontWeight: 'bold',
                textAlign: 'center',
                padding: '5px',
              }}
            >
              {column.text}
            </span>
          );
        },
        title: (cell) => {
          return cell;
        },
      }))) ||
    [];

  const columns = [
    {
      dataField: 'serialNumber',
      text: formatMessage('serial_number'),
      classes: 'show-Elipses',
      isDummyField: true,
      formatter: (_, __, rowIndex) => rowIndex + 1,
      sort: false,
    },
    {
      dataField: 'Id',
      text: formatMessage('serial_number'),
      classes: 'show-Elipses',
      sort: false,
      hidden: true,
    },
    ...dynamicColumns,
  ];

  // Follow the user's saved column order; fixed columns (not in `selected`) stay first.
  const columnPosition = (col: any) =>
    selected.findIndex((s) => s.value === col.dataField);
  const filteredColumns = columns
    .filter((col: any) => allowedColumns.includes(col.dataField))
    .sort((a: any, b: any) => columnPosition(a) - columnPosition(b));

  const handleTableChange = (type: any, newState: any) => {
    if (isFirstLoad.current) {
      isFirstLoad.current = false;
      return;
    }

    setColumnSortOrder((prevState) => ({
      ...prevState,
      dataField: newState.sortField,
      order: newState.sortOrder,
    }));

    const filter = createQueryString({
      ...filterObj,
      Column: newState.sortField,
      Order: newState.sortOrder
    })

    getHKRScheduleViewServiceHandler(filter);
  };

  // useEffect(() => {
  //   const filter = createQueryString({
  //     ...filterObj,
  //     Column: columSortOrder.dataField,
  //     Order: columSortOrder.order,
  //   });

  //   getHKRScheduleViewServiceHandler(filter);
  // }, [columSortOrder]);

  const handleSelectionChange = async (selectedOptions) => {
    if (selectedOptions.length === 0) {
      setSelected([]);
      setAllowedColumns(['checkbox', 'Kishu', 'ProcessDueDate', 'Remaining']);
    } else {
      setSelected(selectedOptions);
      setAllowedColumns([
        ...selectedOptions.map((item) => item.value),
        'checkbox',
        'Kishu',
        'ProcessDueDate',
        'Remaining',
      ]);
    }
    SaveProcessOrderService({
      SettingKey: userSettingEnum.HKRTableColumn,
      ProcessOrder: selectedOptions.map((opt) => opt.label).join(','),
    });
  };

  const handleColumnReorder = (orderedColumns: string[]) => {
    const options = orderedColumns.map((column) => ({
      label: column,
      value: column,
    }));
    setSelected(options);
    setAllowedColumns([
      ...options.map((item) => item.value),
      'checkbox',
      'Kishu',
      'ProcessDueDate',
      'Remaining',
    ]);
  };

  useEffect(() => {
    if (saveProcessOrderState.error) {
      toast.error(formatMessage(saveProcessOrderState.error));
      resetSaveProcessOrderState();
    }
  }, [saveProcessOrderState.error]);

  useEffect(() => {
    if (saveProcessOrderState.success) {
      // toast.success(formatMessage('updated_success'));
      getHKRScheduleViewServiceHandler();
      resetSaveProcessOrderState();
    }
  }, [saveProcessOrderState.success]);

  return (
    <>
      <div className="icon-nav navbar-fixed-top device-nav-bar userTopNav">
        <div className="row align-items-center">
            <Header className='col-lg-6 col-md-6 col-sm-6' label="hkr_schedule" />
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="add-list">
              <li>
                <FilterComponent
                  initialValues={filterObj}
                  id={0}
                  submitHandler={filterHandler}
                  filterParmas={filterParams}
                  onModalClosed={props.filterPopupToggleHandler}
                  isLoading={false}
                  isFilterCleared={isFilterCleared}
                  isFilterApplied={isFilterApplied}
                  setIsFilterApplied={setIsFilterApplied}
                />
              </li>
              <li title={formatMessage('refresh')}>
                <a
                  data-toggle="modal"
                  className="btn btn-light"
                  onClick={() => refreshClickHandler()}
                  // onMouseOver={}
                >
                  <RefreshIcon />
                </a>
              </li>
              <li title={formatMessage('reorder_process')}>
                <a
                  className="btn btn-primary"
                  data-toggle="modal"
                  onClick={props.processReorderToggleHandler}
                >
                  <img
                    src={ReorderProcess}
                    alt=""
                    className="ReorderProcess me-1"
                  />
                  <FormattedMessage id="reorder_process" />
                </a>
              </li>
              <li>
                <MultiSelect
                  //  isOpen={true}
                  hasSelectAll={true}
                  options={allProcesses}
                  value={selected}
                  onChange={handleSelectionChange}
                  labelledBy="Select"
                  className={`multiselect-react product-select ${allHKRDashboardDataList.length === 0 ? 'div-disabled' : ''}`}
                  valueRenderer={() => formatMessage('select_columns')}
                  overrideStrings={{
                    selectAll: formatMessage('select_all_options'),
                    selectAllFiltered: formatMessage('select_all_filtered'),
                    search: formatMessage('search'),
                  }}
                />
              </li>{' '}
            </ul>
          </div>
        </div>
      </div>
      {props.showReorderProcessPopup && (
        <HKRColumnReorder
          id={0}
          modalClosed={props.processReorderToggleHandler}
          allColumns={allProcesses.map((p) => p.label)}
          selectedColumns={selected.map((p) => p.label)}
          onSubmitReorder={handleColumnReorder}
        />
      )}
      <div className={`${openPanel ? 'panelOpen' : ''}`}>
        <div className="card card-page">
          {getHKRDashboardDataServiceState.inProgress && (
            <FormLoader loading={getHKRDashboardDataServiceState.inProgress} />
          )}
          {allHKRDashboardDataList && allHKRDashboardDataList.length > 0 ? (
            <>
              <div>
                <div className="tableDesign row-eq-height tableDevices p-3 changingPanel">
                  <div
                    className="table-responsive"
                    data-testid="table"
                  >
                    {allHKRDashboardDataList && (
                      <Grid
                        data={allHKRDashboardDataList}
                        columns={[
                          {
                            dataField: 'Kishu',
                            text: formatMessage('kishu'),
                            classes: 'show-Elipses',
                            title: (cell) => (cell.length > 10 ? cell : undefined)
                          },
                          {
                            dataField: 'ProcessDueDate',
                            text: formatMessage('process_due_date'),
                            sort: true,
                          },
                          {
                            dataField: 'Remaining',
                            text: formatMessage('remaining'),
                          },
                          {
                            dataField: 'Code',
                            classes: 'show-Elipses',
                            text: formatMessage('code'),
                            title: (cell) => (cell.length > 10 ? cell : undefined)
                          },
                          ...filteredColumns,
                        ]}
                        keyField="Id"
                        loading={false}
                        rowClasses={rowClassFormat}
                        hover={true}
                        sort={{ ...columSortOrder }}
                        remote={{ ...GridRemoteConstant }}
                        onTableChange={handleTableChange}
                      />
                    )}
                  </div>
                </div>
              </div>
              {allHKRDashboardDataList.length > 0 ? (
                <div className="row no-gutters p-3 pt-0 tableFooter">
                  <div className="col-lg-6 col-md-6 col-sm-6 pt-1">
                    <FormattedMessage id="show" />
                    <select
                      data-testid="pageSelect"
                      className="pageLimit"
                      onChange={onPageLimitChanged}
                      value={pageLimitInfo.pageLimit}
                    >
                      {pageLimitOptions.map((op: any) => (
                        <option
                          key={op}
                          value={op}
                        >
                          {op}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6 d-flex justify-content-sm-end">
                    <Pagination
                      isRefreshPage={false}
                      totalPages={pageInfo.totalPages}
                      pageLimit={pageLimitInfo.pageLimit}
                      onPageChanged={onPageChanged}
                      disablePagination={disablePagination}
                      setIsRefreshPage={setIsRefreshPage}
                      currentPage={pageInfo.currentPage}
                      totalRecords={hkrDashboardDataList.PagingDetails.TotalRecords}
                    />
                  </div>
                </div>
              ) : (
                ''
              )}
            </>
          ) : (
            <div className="message">
              <div className="d-flex message-area">
                <div className="no-data-img">
                  <img
                    src={noMessageIcon}
                    alt=""
                    className="no_message"
                  />
                </div>
                <div>
                  <h3 className="fw-bold display-6">
                    {' '}
                    <FormattedMessage id="no_data" />
                  </h3>
                  <h4 className="mb-3">
                    {formatMessage('no_hkr_data_message')}
                  </h4>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ReorderProcessPopupHOC(
  FilterPopupHOC(DeletePopupHOC(observer(HKRDashboardDataView)))
);
